// vendors
import * as Sentry from "@sentry/react";

import { getSentryConfig } from "@/Environment";

export const Tracing = {
  init: () => {
    try {
      const config = getSentryConfig();
      if (config.environment === "dev") {
        return;
      }
      console.debug("Configuring tracing", config);
      Sentry.init({
        ...config,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.breadcrumbsIntegration({
            console: false,
          }),
        ],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
      });
    } catch (error) {
      console.error("Tracing init", error);
    }
  },
  capture: (exception: any) => {
    try {
      Sentry.captureException(exception);
    } catch (error: any) {
      console.error("Tracing.capture error", error.message, exception);
    }
  },
  captureMessage: (message: any, context: any) => {
    try {
      Sentry.captureMessage(message, context);
    } catch (error: any) {
      console.error("Tracing.captureMessage error", error.message, message);
    }
  },
  setUser: (user: any) => {
    try {
      Sentry.setUser(user);
    } catch (error: any) {
      console.error("Tracing.setUser error", error.message, user);
    }
  },
};
